module.exports = __webpack_public_path__ + "static/media/2 (2).57a7bf5b.JPG";